import { ListItemIcon } from '../List/ListItemIcon';
import { ListItemText } from '../List/ListItemText';
import { Divider } from '../Divider/Divider';
import { Menu as Root } from './Menu';
export { type MenuProps } from './Menu';
import { MenuItem, type MenuItemProps } from './MenuItem';
import { MenuList, type MenuListProps } from './MenuList';
export * from './useMenu';

export { MenuItem, MenuItemProps, MenuList, MenuListProps };

export const Menu = Object.assign(Root, {
  Item: MenuItem,
  /**
   * Do not use Menu.List inside Menu because Menu by default adds Menu.List
   */
  List: MenuList,
  Divider: Divider,
  ItemIcon: ListItemIcon,
  ItemText: ListItemText
});
